import type { ReactNode } from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export type AssessmentFact = { label: string; value: string };

/** The "This assessment" card: its key facts, each a label over a value, and any actions beneath. */
export const AssessmentFacts = ({
  facts,
  children,
}: {
  facts: readonly AssessmentFact[];
  children?: ReactNode;
}) => {
  const { t } = useTranslation();

  return (
    <Paper variant="outlined" sx={{ p: 3, alignSelf: "flex-start" }}>
      <Stack spacing={2}>
        <Typography variant="h6" component="h2">
          {t("assessment.overview.thisAssessment")}
        </Typography>
        {facts.map(({ label, value }) => (
          <Box key={label}>
            <Typography
              variant="caption"
              color="text.secondary"
              component="div"
            >
              {label}
            </Typography>
            <Typography>{value}</Typography>
          </Box>
        ))}
        {children}
      </Stack>
    </Paper>
  );
};
